import React from "react";
import {
  ReadMessageIcon,
  UnreadMessageIcon,
} from "src/components/Projects/Icons";

export const MessageIcon = ({ unread }: { unread: boolean | null }) => {
  if (unread === true) {
    return <UnreadMessageIcon />;
  }
  if (unread === false) {
    return <ReadMessageIcon />;
  }
  return null;
};
